export class PaymentHistory {
    totalRecords: number;
    records: PaymentHistoryEntry[];
    page: number;

    constructor(totalRecords: number, records: {[key: string]: any}[]) {
        this.totalRecords = totalRecords;
        this.records = records.map((record) => {
            return new PaymentHistoryEntry(
                record.uid,
                record.amount,
                record.currency,
                record.created,
                record.amountTotal,
                record.tax,
                record.status,
                record.invoiceUrl,
                record.invoiceNumber,
                record.message
            );
        })
        this.page = 1;
    }

    addMore(records: {[key: string]: any}[]) {
        this.records = this.records.concat(records.map((record) => {
            return new PaymentHistoryEntry(
                record.uid,
                record.amount,
                record.currency,
                record.created,
                record.amountTotal,
                record.tax,
                record.status,
                record.invoiceUrl,
                record.invoiceNumber,
                record.message
            );
        }));
        this.page += 1;
    }
}

export class PaymentHistoryEntry {
    uid: number;
    amount: number;
    currency: string;
    created: number;
    amountTotal: number;
    tax: number;
    status: string;
    invoiceUrl: string;
    invoiceNumber: number | null;
    message?: string;

    constructor(
        uid: number,
        amount: number,
        currency: string,
        created: number,
        amountTotal: number,
        tax: number,
        status: string,
        invoiceUrl: string,
        invoiceNumber: number | null,
        message?: string
    ) {
        this.uid = uid;
        this.amount = amount;
        this.currency = currency;
        this.created = created;
        this.amountTotal = amountTotal;
        this.tax = tax;
        this.status = status;
        this.invoiceUrl = invoiceUrl;
        this.invoiceNumber = invoiceNumber;
        this.message = message;
    }

    getTax() {
        return this.amountTotal - this.amount;
    }
}
